import { lazy } from 'react';
import { PermissionsGuard } from './components';
import {
    CREATE_PERMISSION,
    READ_PERMISSION,
    TEMPLATES_WSP_AUTH,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';

export const Routes = [
    {
        exact: true,
        path: '/management/system-notifications',
        guard: PermissionsGuard,
        roles: {
            permission: TEMPLATES_WSP_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(
            () =>
                import(
                    'src/views/systemNotifications/SystemNotificationsView'
                )
        ),
    },
    {
        exact: true,
        path: '/create/template-wsp/meta',
        guard: PermissionsGuard,
        roles: {
            permission: TEMPLATES_WSP_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(
            () => import('src/views/templateTwilio/MetaTemplateCreateView')
        ),
    },
    {
        exact: true,
        path: '/create/template-wsp',
        guard: PermissionsGuard,
        roles: {
            permission: TEMPLATES_WSP_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(
            () => import('src/views/templateTwilio/TemplateTwilioCreateView')
        ),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: TEMPLATES_WSP_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/templates-wsp/:id',
        component: lazy(
            () => import('src/views/templateTwilio/TemplateTwilioDetailsView')
        ),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: TEMPLATES_WSP_AUTH,
            crud: UPDATE_PERMISSION,
        },
        path: '/management/template-wsp/:id/edit',
        component: lazy(
            () => import('src/views/templateTwilio/TemplateTwilioEditView')
        ),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: TEMPLATES_WSP_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/templates-wsp',
        component: lazy(
            () => import('src/views/templateTwilio/TemplateTwilioListView')
        ),
    },
];
